import React from 'react';
import { Dynamo } from '../../../primary-record-types';
import addressToString from '../../../utils/addressToString';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import Icon, { IconName } from '../../v2BaseComponents/Icon';
import Text from '../../v2BaseComponents/Text';
import { ClickableLinkText } from '../../v2BaseComponents/Link';

export type ContactDetailsDisplayProps = {
    contactDetails: Omit<Dynamo.ContactDetails, 'contactDetailsId' | 'sourceEntityId' | 'entityType' | 'contactType'>;
};

const IconText: React.FC<{ icon: IconName; children: React.ReactNode }> = (props) => {
    return (
        <Stack horizontal space={contentStackSpacing} align="flex-start">
            <Icon name={props.icon} size="button-icon" />
            {props.children}
        </Stack>
    );
};

const ContactDetailsDisplay: React.FC<ContactDetailsDisplayProps> = ({ contactDetails }) => {
    const address = addressToString(contactDetails);
    return (
        <Stack vertical space={2}>
            {contactDetails.email ? (
                <IconText icon="Mail">
                    <ClickableLinkText linkType="email" variant="body-1">
                        {contactDetails.email}
                    </ClickableLinkText>
                </IconText>
            ) : null}
            {contactDetails.phoneNumber ? (
                <IconText icon="Phone">
                    <ClickableLinkText linkType="phone" variant="body-1">
                        {contactDetails.phoneNumber}
                    </ClickableLinkText>
                </IconText>
            ) : null}
            {contactDetails.faxNumber ? (
                <IconText icon="Print">
                    <Text variant="body-1">{contactDetails.faxNumber}</Text>
                </IconText>
            ) : null}
            {contactDetails.url ? (
                <IconText icon="Link">
                    <ClickableLinkText linkType="url" variant="body-1">
                        {contactDetails.url}
                    </ClickableLinkText>
                </IconText>
            ) : null}
            {address ? (
                <IconText icon="MapPin">
                    <ClickableLinkText linkType="address" variant="body-1">
                        {address}
                    </ClickableLinkText>
                </IconText>
            ) : null}
        </Stack>
    );
};

export default React.memo(ContactDetailsDisplay);
